import { LoanReturnAdvancedValues, LoanReturnAdvancedResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

// Inputs: borrowedInvested, interestPercent, ownCapital, expectedReturnPercent
// Outputs: netAmountPerYear, returnOnEquityPercent, leverageMultiple
export function calculateLoanReturnAdvanced(values: LoanReturnAdvancedValues, t?: ToolsTranslations['loanReturnAdvanced']): LoanReturnAdvancedResult {
  const { borrowedInvested, interestPercent, ownCapital, expectedReturnPercent } = values;
  if (borrowedInvested < 0 || ownCapital < 0) return { netAmountPerYear: null, roePercentPerYear: null, leverageMultiple: null, isValid: false, message: t?.invalid.generic };
  if (interestPercent < 0 || expectedReturnPercent < 0) return { netAmountPerYear: null, roePercentPerYear: null, leverageMultiple: null, isValid: false, message: t?.invalid.generic };

  const totalInvested = borrowedInvested + ownCapital;
  const grossReturn = totalInvested * (expectedReturnPercent / 100);
  const interestCost = borrowedInvested * (interestPercent / 100);
  const net = grossReturn - interestCost;
  const roe = ownCapital > 0 ? (net / ownCapital) * 100 : null;
  const leverage = ownCapital > 0 ? totalInvested / ownCapital : null;

  const netRounded = Math.round(net);
  const roeRounded = roe !== null ? Math.round(roe * 100) / 100 : null;
  const leverageRounded = leverage !== null ? Math.round(leverage * 10) / 10 : null;

  return { netAmountPerYear: netRounded, roePercentPerYear: roeRounded, leverageMultiple: leverageRounded, isValid: true };
}


